var _a;
import { OnDestroy, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry, } from '@app/router';
import { AccessCode } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, merge, Subject, } from 'rxjs';
import { filter, map, switchMap, switchMapTo, takeUntil, tap, } from 'rxjs/operators';
var CODE_TO_TRANSLATION = (_a = {},
    _a[AccessCode.NotFound] = 'notfound_page',
    _a[AccessCode.FeatureNotEnabled] = 'feature_not_enabled_page',
    _a[AccessCode.FolderRequired] = 'access_denied_folder_required',
    _a[AccessCode.PermissionRequired] = 'access_denied_general',
    _a[AccessCode.FeatureNotLicensed] = 'feature_not_licensed_page',
    _a[AccessCode.ClassicFolderRequired] = 'classic_folder_required_message',
    _a);
var RestrictedAccessPageComponent = /** @class */ (function () {
    function RestrictedAccessPageComponent(route, pageRegistry, title, appState, translate, router) {
        var _this = this;
        this._destroyed$ = new Subject();
        this.code$ = route.queryParamMap
            .pipe(map(function (params) {
            var reason = params.get('reason');
            var reasonAsNumber = Number(reason);
            if (reason == null ||
                isNaN(reasonAsNumber)) {
                return AccessCode.NotFound;
            }
            return reasonAsNumber;
        }));
        this.page$ = route.queryParamMap
            .pipe(map(function (params) {
            var target = params.get('target') || '';
            return pageRegistry.find(target);
        }));
        this.message$ = combineLatest([this.code$, this.page$])
            .pipe(map(function (_a) {
            var code = _a[0], page = _a[1];
            return _this._extractTranslationKey(code, page);
        }), switchMap(function (translateKey) { return translate.stream(translateKey || ''); }), tap(function (translatedMessage) { return title.setTitle(translatedMessage + " - " + appState.authConfig.value.serverSettings.baseTitle); }));
        var changes$ = merge([
            appState.user.permissions.change$,
            appState.user.folder.change$,
        ]);
        changes$
            .pipe(switchMapTo(combineLatest([
            this.code$,
            this.page$,
        ])), filter(function (_a) {
            var reason = _a[0], page = _a[1];
            return !!page && [AccessCode.ClassicFolderRequired, AccessCode.FolderRequired, AccessCode.PermissionRequired].includes(reason);
        }), takeUntil(this._destroyed$)).subscribe(function (_a) {
            var _ = _a[0], page = _a[1];
            router.navigate([page.routerLink]);
        });
    }
    RestrictedAccessPageComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    RestrictedAccessPageComponent.prototype._extractTranslationKey = function (code, page) {
        if (page &&
            [AccessCode.ClassicFolderRequired, AccessCode.FolderRequired].includes(code) &&
            page.folderTypeDependencyMessage) {
            return page.folderTypeDependencyMessage;
        }
        return CODE_TO_TRANSLATION[code];
    };
    return RestrictedAccessPageComponent;
}());
export { RestrictedAccessPageComponent };
